import { Box, Divider, Typography } from '@mui/material';
import { ReactNode } from 'react';

import { layoutWrapper } from 'styles/components/LayoutStyle';

interface LayoutProps {
  children: ReactNode;
  pageTitle?: string;
  styles?: {
    [key: string]: {};
  };
}

export const Layout = (props: LayoutProps) => {
  const { children, styles, pageTitle } = props;

  return (
    <Box sx={{ ...layoutWrapper, ...styles }}>
      {pageTitle && (
        <Typography variant="h2" align="left">
          {pageTitle}
        </Typography>
      )}
      {pageTitle !== undefined && (
        <Divider
          sx={{
            opacity: '0.6'
          }}
        />
      )}
      {children}
    </Box>
  );
};
